import { Box } from '@domain-group/suit-theme'

import OrderItemTask from './OrderItemTask'

type ItemManagementProps = {
  orderItemPayload: {
    requiredItems: {
      artwork: boolean,
      orderItemTask: boolean,
    },
  },
}

const ItemManagement = (props: ItemManagementProps) => {
  const {
    orderItemPayload: {
      requiredItems,
    },
  } = props

  if (!requiredItems.orderItemTask){
    return null
  }

  return (
    <Box flexDirection="column" paddingX="large" paddingBottom="large">
      {requiredItems.orderItemTask && (
        // @ts-expect-error TS2322
        <OrderItemTask {...props} />
      )}
    </Box>
  )
}

export default ItemManagement
